import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["data-state", "data-testid"]
const _hoisted_2 = {
  viewBox: "0 0 24 24",
  class: "h-3.5 w-3.5 shrink-0",
  fill: "currentColor",
  "aria-hidden": "true"
}
const _hoisted_3 = ["d"]

import {
  mdiAlertCircleOutline,
  mdiAlertOutline,
  mdiCheck,
  mdiClockOutline,
  mdiFlash,
  mdiProgressClock
} from '@mdi/js'

import type { PrioritySlaState } from '@/Network/Types/Responses/PriorityPaymentsResponses'

import { PRIORITY_SLA_STATE_LABELS } from '../slaFormat'


export default /*#__PURE__*/_defineComponent({
  __name: 'PrioritySlaStateBadge',
  props: {
    state: {},
    testId: { default: 'priority-sla-state-badge' }
  },
  setup(__props: any) {



/** Ícone + cor: o estado não depende só da cor (daltonismo). */
const STATE_ICON: Record<PrioritySlaState, string> = {
  OVERDUE: mdiAlertCircleOutline,
  URGENT: mdiFlash,
  ATTENTION: mdiAlertOutline,
  ON_TIME: mdiClockOutline,
  DONE: mdiCheck,
  NOT_STARTED: mdiProgressClock
}

const STATE_CLASS: Record<PrioritySlaState, string> = {
  OVERDUE: 'bg-red-700 text-white',
  URGENT: 'bg-orange-100 text-orange-800',
  ATTENTION: 'bg-amber-100 text-amber-800',
  ON_TIME: 'bg-blue-50 text-blue-700',
  DONE: 'bg-green-50 text-green-700',
  NOT_STARTED: 'border border-dashed border-neutral50/40 bg-white text-neutral50'
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(["inline-flex w-fit items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold", STATE_CLASS[_ctx.state]]),
    "data-state": _ctx.state,
    "data-testid": _ctx.testId
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_2, [
      _createElementVNode("path", {
        d: STATE_ICON[_ctx.state]
      }, null, 8, _hoisted_3)
    ])),
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createTextVNode(_toDisplayString(_unref(PRIORITY_SLA_STATE_LABELS)[_ctx.state]), 1)
    ])
  ], 10, _hoisted_1))
}
}

})